import { render, staticRenderFns } from "./site-setup-search.component.vue?vue&type=template&id=6e44fa04"
import script from "./site-setup-search.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-search.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-search.component.vue?vue&type=style&index=0&id=6e44fa04&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e44fa04')) {
      api.createRecord('6e44fa04', component.options)
    } else {
      api.reload('6e44fa04', component.options)
    }
    module.hot.accept("./site-setup-search.component.vue?vue&type=template&id=6e44fa04", function () {
      api.rerender('6e44fa04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-search/site-setup-search.component.vue"
export default component.exports